import { type ChangeEvent, useCallback, useMemo, useState, KeyboardEvent } from "react";
import { createSearchParams, useNavigate } from "react-router-dom";
import { Container, SliceBorder, TextField, Title } from "../../../shared/ui";
import { HeroBlock } from "../../../entities/HeroBlock";
import { Search } from "../../../shared/assets/svg";
import { searchVariants, imageAttributes, title, mobileTitle } from "../const/HomeMain.data";
import { useMediaQuery } from "../../../shared/hooks/useMediaQuery";
import { generateMediaQuery } from "../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../shared/constants/media";
import AutoCarousel from "../../AutoCarousel";
import { getRouteVacancies } from "../../../shared/constants/routes";
import { SearchParamsVacancyEnum } from "../../../shared/constants/searchParams";

import styles from "./HomeMain.module.scss";

const HomeMain = () => {
    const matches = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));
    const [value, setValue] = useState("");
    const navigate = useNavigate();

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.currentTarget.value);
    };

    const redirectToVacancies = useCallback(
        (searchQuery: string, take?: number) => {
            if (!searchQuery) {
                return;
            }
            navigate({
                pathname: getRouteVacancies(),
                search: createSearchParams({
                    [SearchParamsVacancyEnum.SEARCH]: searchQuery,
                    [SearchParamsVacancyEnum.TAKE]: take?.toString() || "3",
                }).toString(),
            });
        },
        [navigate],
    );

    // Событие по кнопке Enter
    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            redirectToVacancies(value);
        }
    };

    const list = useMemo(
        () =>
            searchVariants.map((text, idx) => ({
                id: idx.toString(),
                node: (
                    <button key={text} onClick={() => redirectToVacancies(text, 100)} className={styles.tab}>
                        {text}
                    </button>
                ),
            })),
        [redirectToVacancies],
    );

    const carousel = (
        <div className={styles.tabs}>
            <AutoCarousel data={list} playbackRate={0.0000001} />
        </div>
    );

    const searchField = (
        <TextField
            className={styles.mobileInput}
            value={value}
            autoComplete="off"
            placeholder="Название должности или направления"
            startDecorator={<Search />}
            onChange={handleChange}
            onKeyDown={handleKeyPress}
            onClick={() => redirectToVacancies(value)}
        />
    );

    return (
        <Container className={styles.wrapper} marginSize={matches ? "standard" : undefined}>
            {!matches && (
                <div className={styles.background}>
                    <HeroBlock imageAttributes={imageAttributes} title={title}>
                        <div>
                            <div className={styles.inputWrapper}>
                                <div className={styles.form}>{searchField}</div>
                            </div>
                            {carousel}
                        </div>
                    </HeroBlock>
                </div>
            )}
            {matches && (
                <div>
                    <Title className={styles.title} level={1}>
                        {mobileTitle.first}
                    </Title>
                    <div className={styles.wrapperImg}>
                        <img className={styles.img} src={imageAttributes.src} alt={mobileTitle.first} />
                        <SliceBorder
                            sizeRadius={12}
                            className={styles.wrapperTitle}
                            border={{
                                bottomRight: "inside",
                                topRight: "outside-corner-lateral",
                                bottomLeft: "outside-corner-upper",
                            }}
                        >
                            <Title className={styles.title} level={1}>
                                {mobileTitle.second}
                            </Title>
                        </SliceBorder>
                    </div>
                    <div className={styles.form}>{searchField}</div>
                    {carousel}
                </div>
            )}
        </Container>
    );
};

export { HomeMain };
